$(document).ready(function() {

  function header() {
    if($('.body-padding').length <= 0 ) {
      let headerHeight = $('.header__announcement').outerHeight();
      $('body').css('paddingTop', `${headerHeight}px`)

      $(window).on('resize', function() {
        headerHeight = $('.header__announcement').outerHeight();
        $('body').css('paddingTop', `${headerHeight}px`)
      })

      $(window).on('scroll', function() {
        if($(document).scrollTop() > 100) {
          $('body').addClass('scrolled');
        } else {
          $('body').removeClass('scrolled');
        }       


        if($(window).width() < 992) {          
          if($(document).scrollTop() > 504) {
            $('.header').hasClass('inverted-black')?$('.header').removeClass('inverted-black'):$('.header').removeClass('inverted');
          } else {
            $('body').hasClass('template--pageapp')?$('.header').addClass('inverted-black'):$('.header').addClass('inverted');
          }
        } else {
          if($(document).scrollTop() > 660) {
            $('.header').hasClass('inverted-black')?$('.header').removeClass('inverted-black'):$('.header').removeClass('inverted');
          } else {
            $('body').hasClass('template--pageapp')?$('.header').addClass('inverted-black'):$('.header').addClass('inverted');
          }
        }
    });
    } else {
      let headerHeight = $('.header').outerHeight();
      $('body').css('paddingTop', `${headerHeight}px`)

      $(window).on('resize', function() {
        headerHeight = $('.header').outerHeight();
        $('body').css('paddingTop', `${headerHeight}px`)
      })
    }
  }

  function announcement() {
    let container = $('.header__announcement'),
        containerClose = $('.header__announcement-close');

    containerClose.click(function() {
      container.hide();
      localStorage.setItem('announcementClosed', 'closed')
      $('body').removeClass('show-announcement')
    })
    if(localStorage.getItem('announcementClosed') !== 'closed') {
      container.show();
      $('body').addClass('show-announcement')
    }
  }

  function mobileMenu() {
    let burger = '.header__burger',
        mobileMenu = '.mobile-menu',
        expand = '.mobile-menu__catalog-link__inner--toggle',
        expandedMenu = '.mobile-menu__more',
        closeExpanded = '.mobile-menu__more-title',
        closeMenu = '.mobile-menu__close'

    $(burger).click(() => {
      $('body').toggleClass('muted');
      $('body').toggleClass('menu-opened');
      $(mobileMenu).toggleClass('active');
    })

    $(expand).click(function() {
      $(this).closest('.mobile-menu__catalog-link').find(expandedMenu).addClass('active');
    })

    $(closeExpanded).click(function() {
      $(this).closest(expandedMenu).removeClass('active');
    })
  }

  function lazy() {
    //add simple support for background images:
    document.addEventListener('lazybeforeunveil', function(e){
      var bg = e.target.getAttribute('data-bg');
      if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
      }
    });
  }

  function homeAnimation() {
   
    $(window).scroll(function () {
      let scrollPos = $(document).scrollTop();

      $('.promo__bg.d-lg-block').each(function() {
        let offsetT  = $(this).offset()
         $(this).css('transform', `translateY(${(scrollPos - offsetT.top) / 5}px)`)
        
      })

      if(window.innerWidth >= 1008) {
        $('.usp__image').each(function() {
          if($(this).hasClass('aos-animate')){
            let offsetT  = $(this)[0].offsetTop
            $(this).children('img').css('transform', `translateY(${(scrollPos - offsetT) / 8}px)`)
          }
        })
      }
    });


  }

  function sliders() {
    $('.f-products__image').slick({
      draggable: false
    });

    $('.f-products__list .slider__info-arrow---prev').click(function() {
      $(this).closest('.f-products__list').find('.slick-prev').click();
      let index = $(this).closest('.f-products').find('.slick-active').attr('data-slick-index');
      $(this).closest('.f-products').find('.slider__info-count span').html(+index + 1)
    })
    $('.f-products__list .slider__info-arrow---next').click(function() {
      $(this).closest('.f-products__list').find('.slick-next').click();
      let index = $(this).closest('.f-products').find('.slick-active').attr('data-slick-index');
      $(this).closest('.f-products').find('.slider__info-count span').html(+index + 1)
    })

    if($('.p-promo__slide').length > 1) {
      $('.p-promo__slides').slick({
        fade: true,
        speed: 1100,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              arrows: false
            }
          }
        ]
      });
    }
  }

  function instFunctions() {
    var target = document.getElementById('insta-feed');

    const config = {
      childList: true,
    };

    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          setTimeout(function() {
            $('.instafeed-lightbox').remove();
            $('#insta-feed').slick({
              infinite: false,
              slidesToShow: 4,
              centerMode: false,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    variableWidth: true,
                    centerMode: true
                  }
                }
              ]
            });
            observer.disconnect();
          }, 2000)
        }
      }
    };

    const observer = new MutationObserver(callback);
    if(target) {observer.observe(target, config);}
  }

  function productLanding() {
    if($('.template--pageproduct').length || $('.template--pagefovi').length ) {
      var anchors = '.tabs__item';
      var anchorsBlocks = ['#overview', '#design', '#reviews', '#showcase'];
      const tabItem = $('.product-links__select')

      tabItem.on('change', function() {
         const mobBlock = `#${$(this).val().replace(' ', '-')}`
         $("html, body").animate({ scrollTop: $(mobBlock).offset().top - 135 }, 444);
      })

      $(anchors).click(function(e) {
        e.preventDefault();
        var block = $(this).attr('href')
        $("html, body").animate({ scrollTop: $(block).offset().top - 135 }, 444);
      })


      // $(window).scroll(function () {
      //   // anchorsBlocks.forEach(elem => isInViewport(elem));
      //   productAppsAnimation();

      //   let scrollPos = $(document).scrollTop();
      //   let offsetT  = $('.iwt-image-wrapper')[0].offsetTop
      //   if(window.innerWidth > 991) {
      //     $('.p-promo__slide img').css('transform', `translateY(${scrollPos / 5}px)`)
      //   }
      //   $('.iwt__image').css('transform', `translateY(${(scrollPos - offsetT) / 5}px)`)
      // });
    }
  }

  // function isInViewport (elem) {
  //   if($('.template--pageproduct').length && window.innerWidth >= 992 ) {
  //     // let tabsLine = $('.tabs__line')
  //     let elementTop = $(elem).offset().top + $(window).height() - 160;
  //     let elementBottom = elementTop + $(elem).outerHeight() - $(window).height();

  //     let viewportTop = $(window).scrollTop();
  //     let viewportBottom = viewportTop + $(window).height();


  //     if(elementBottom > viewportTop && elementTop < viewportBottom) {
  //       $(`.tabs__item[data-anchor=${elem.replace('#', '')}]`).addClass('active');

  //         let left = $(`.tabs__item[data-anchor=${elem.replace('#', '')}]`).offset().left - 40;
  //         let width =$(`.tabs__item[data-anchor=${elem.replace('#', '')}]`).width();
  //         tabsLine.css('left', left)
  //         tabsLine.css('width', width)
  //     }
  //     else {
  //       $(`.tabs__item[data-anchor=${elem.replace('#', '')}]`).removeClass('active');
  //     }
  //   }
  // };

  function productAppsAnimation() {
    if($('#save-with-the-app').length) {
      let appsOffset = $('#save-with-the-app').offset().top;
      let step = 70;
      let scroll = $(window).scrollTop() - appsOffset + 73;
      if(scroll > step*2 && scroll <= step*4) {
        $('.p-apps__block--1').removeClass('active');
        $('.p-apps__block--3').removeClass('active');
        $('.p-apps__block--2').addClass('active');

        $('.p-apps__img--1').removeClass('active');
        $('.p-apps__img--3').removeClass('active');
        $('.p-apps__img--2').addClass('active');
      }
      else if(scroll > step*4) {
        $('.p-apps__block--1').removeClass('active');
        $('.p-apps__block--2').removeClass('active');
        $('.p-apps__block--3').addClass('active');

        $('.p-apps__img--1').removeClass('active');
        $('.p-apps__img--2').removeClass('active');
        $('.p-apps__img--3').addClass('active');
      }
      else if(scroll <= step*2) {
        $('.p-apps__block--2').removeClass('active');
        $('.p-apps__block--3').removeClass('active');
        $('.p-apps__block--1').addClass('active');

        $('.p-apps__img--2').removeClass('active');
        $('.p-apps__img--3').removeClass('active');
        $('.p-apps__img--1').addClass('active');
      }
    }
  }

  function homeApps() {
    if($('#hApps').length && $(window).width() > 767) {

      let multi = 3;
      let scrolled = false;
      if($(window).width() >= 1920) {
        multi = 4;
      }


      $(window).scroll(() => {

        let appsOffset = $('#hApps').offset().top;
        let step = ($(window).height()) / 2;
        let scroll = $(window).scrollTop() - appsOffset + 150;
  
        if(($(window).scrollTop() + 150) > appsOffset && !scrolled) {
          disableScroll();
          scrolled = true;
          $('#hApps').addClass('active');
          $('.h-app__img-wrap').addClass('active');
          $('.h-app__blocks').addClass('active');
          $('.h-app__title').hide();
          enableScroll();
        }
        // $('.h-app__content--2').addClass('active');
        // $('.h-app__img--2').addClass('active');
        // $('.h-app__content--3').addClass('active');
        // $('.h-app__img--3').addClass('active');
        // $('.h-app__content--4').addClass('active');
        // $('.h-app__img--4').addClass('active');
        if((scroll) > step && (scroll - 250) <= step*2) {
          $('.h-app__content--1').removeClass('active');
          $('.h-app__content--3').removeClass('active');
          $('.h-app__content--4').removeClass('active');
          $('.h-app__content--2').addClass('active');

          $('.h-app__img--1').removeClass('active');
          $('.h-app__img--3').removeClass('active');
          $('.h-app__img--4').removeClass('active');
          $('.h-app__img--2').addClass('active');
        }
        else if((scroll + 150) > step*2 && (scroll - 350) < step*3) {
          $('.h-app__content--1').removeClass('active');
          $('.h-app__content--2').removeClass('active');
          $('.h-app__content--4').removeClass('active');
          $('.h-app__content--3').addClass('active');

          $('.h-app__img--1').removeClass('active');
          $('.h-app__img--2').removeClass('active');
          $('.h-app__img--4').removeClass('active');
          $('.h-app__img--3').addClass('active');
        }
        else if((scroll +250) >= step*3) {
          $('.h-app__content--1').removeClass('active');
          $('.h-app__content--2').removeClass('active');
          $('.h-app__content--3').removeClass('active');
          $('.h-app__content--4').addClass('active');

          $('.h-app__img--1').removeClass('active');
          $('.h-app__img--2').removeClass('active');
          $('.h-app__img--3').removeClass('active');
          $('.h-app__img--4').addClass('active');
        }
        else if(scroll <= step) {
          $('.h-app__content--2').removeClass('active');
          $('.h-app__content--3').removeClass('active');
          $('.h-app__content--4').removeClass('active');
          $('.h-app__content--1').addClass('active');

          $('.h-app__img--2').removeClass('active');
          $('.h-app__img--3').removeClass('active');
          $('.h-app__img--4').removeClass('active');
          $('.h-app__img--1').addClass('active');
        }
      })
    }
  }


  function disableScroll() {
    $('body').addClass('stop-scroll');
  }

  function enableScroll() {
    $('body').removeClass('stop-scroll');
  }

  function specification() {
    var maxHeight = 180,
        toggler = false;

    var selectors = {
      specsMain: '.specification__main',
      specsList: '.specification__list',
      specsItem: '.specification__item',
      specsBlock: '.specification__block',
      specsCaptionLink: '.specification__captions-link',
      specsCaptionItem: '.specification__captions-item',
      specsButton: '.specification__button .button'
    }

    if ($(selectors.specsList).height() > maxHeight) {
      toggler = true;
    }
    else {
      $(selectors.specsMain).addClass('full');
    };

    $(selectors.specsButton).click((e) => {
      // $(selectors.specsMain).toggleClass('open');

      if ($(selectors.specsMain).hasClass('open')) {
        $(selectors.specsMain).removeClass('open');
        $(selectors.specsBlock).height(maxHeight + 'px');
      } else {
        $(selectors.specsBlock).height('');
        $(selectors.specsMain).addClass('open');
        $(selectors.specsBlock).height($(selectors.specsMain).find(selectors.specsList).height());
      }
    });

    $(selectors.specsCaptionLink).click((e) => {
      e.preventDefault();

      var index = $(e.currentTarget).parents(selectors.specsCaptionItem).index();

      $(selectors.specsCaptionItem).removeClass('active');
      $(e.currentTarget).parents(selectors.specsCaptionItem).addClass('active');

      $(selectors.specsItem).removeClass('active');
      $(selectors.specsItem).eq(index).addClass('active');
    });
  }

  function variants() {
    $('[data-variant-position]').change((e) => {
      // console.log($(e.currentTarget))
      var changeInputType = $(e.currentTarget).attr('type');
      var value = '';

      if (changeInputType == 'checkbox') {
        if ($(e.currentTarget).prop('checked')) {
          value = 'Yes';

          var captions = $(e.currentTarget).parents('.variants-kit__values').find('.variants-kit__option-title');
          captions.each(function(index) {
            if ($( this ).text() == 'Yes') {
              captions.removeClass('active')
              $(this).addClass('active');
            }
          });
        }
        else {
          value = 'No';

          var captions = $(e.currentTarget).parents('.variants-kit__values').find('.variants-kit__option-title');
          captions.each(function(index) {
            if ($( this ).text() == 'No') {
              captions.removeClass('active')
              $(this).addClass('active');
            }
          });
        }
      }
      else {
        value = $(e.currentTarget).val();

        var captions = $(e.currentTarget).parents('.variants-kit__values').find('.variants-kit__option-title');
        captions.each(function(index) {
          if ($( this ).text() == value) {
            captions.removeClass('active')
            $(this).addClass('active');
          }
        });
      }

      var option = $(e.currentTarget).data('variant-position');
      var defaultSelect = $('.product-form-product-kit-template').find('[data-index="' + option + '"]');

      if (defaultSelect.length != 0) {
        $(defaultSelect)
          .val(value);

        var event = new Event('change', {'bubbles': true, 'cancelable': true});
        var el = document.querySelector('.product-form-product-kit-template [data-index="' + option + '"]');
        el.dispatchEvent(event)
      }

      /* update splitit price */
      // console.log(variant);
      // console.log($('.kit-payments__text [data-part-price]'));
      // $('[data-part-price]')


      /*if ($('[data-sale-price]').parents('.price__sale').css('display') == 'none') {
        // regular price
        // console.log('none');
        console.log($('[data-regular-price]').eq(0).text());
        // console.log($('[data-regular-price]').eq(0).text().slice(0, 1));

      }
      else {
        // sale exist

      }

      console.log($('[data-sale-price]'));
      // console.log($('[data-sale-price]').css('display'));
      console.log($('[data-sale-price]').parents('.price__sale').css('display'));
      // console.log($('[data-regular-price]'));
*/
    });

    $('#resizing_select').change((e) => {
      var $opt = $(e.currentTarget).find("option:selected");
      var $span = $('<span>').addClass('tester').text($opt.text());

      $span.css({
        'font-family': $opt.css('font-family'),
        'font-style': $opt.css('font-style'),
        'font-weight': $opt.css('font-weight'),
        'font-size': $opt.css('font-size'),
        'letter-spacing': $opt.css('letter-spacing')
      });

      $('body').append($span);
      $(e.currentTarget).width($span.width() + 20);
      $span.remove();
    });
  }

  function kitMedia() {
    var selectors = {
      slider: '.kit-media__slider',
      thumbsSlider: '.thumbs-slider',
      sliderPagination: '.kit-media__pagination'
    };

    var slider = $(selectors.slider);
    // var pagination = $(selectors.sliderPagination);
    var thumbsSlider = $(selectors.thumbsSlider)

    // slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //     //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    //     var i = (currentSlide ? currentSlide : 0) + 1;
    //     pagination.text(i + ' of ' + slick.slideCount);
    // });

    slider.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrow: false,
      dots: false,
      prevArrow: '.kit-media__arrow--prev',
      nextArrow: '.kit-media__arrow--next',
      adaptiveHeight: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      asNavFor: '.thumbs-slider'
    });

    thumbsSlider.slick({
      asNavFor: '.kit-media__slider',
      focusOnSelect: true,
      arrows: false,
      dots: false,
      slidesToShow: 6,
      slidesToScroll: 1,
    })

    $('.variants-kit__option-input--plug').on('click', function() {
      let index = $(this).attr('data-index')
      if(index == 1) {
        slider.slick('slickGoTo', 0)
      }
      if(index == 2) {
        slider.slick('slickGoTo', 1)
      }
    })

    $('.variants-kit__option-input--color').on('click', function() {
      let index = $(this).attr('data-index')
      if(index == 1) {
        slider.slick('slickGoTo', 0)
      }
      if(index == 2) {
        slider.slick('slickGoTo', 6)
      }
    })


  }

  function kitPopup() {
    $('.kit-payments__help').click((e) => {
      $('.kit-popup').fadeIn();
    });
    $('.kit-popup').click((e) => {
      $(e.currentTarget).fadeOut();
    });
  }

  function pageHeader() {
    var selectors = {
      button: '.page-header__btn',
      main: '.page__main'
    };
    
    $(selectors.button).click((e) => {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $(selectors.main).offset().top
      }, 400);
    })
  }

  function appTabs() {
    const $title   = $('.app-tabs .app-tabs__title')
    const $content = $('.app-tabs .app-tabs__content')
    const className = 'active'

    $title.on('click', function() {
      if(!($(this).hasClass(className))) {
        $title.removeClass(className)
        $(this).addClass(className)
        const index = $(this).attr('data-index')

        $content.removeClass(className)
        $(this).parent().next().find(`[data-index=${index}]`).addClass(className)
      }
    })
  }

	function collectionsTabs() {
    const $title   = $('.collection_tabs .app-tabs__title')
    const $content = $('.collection_tabs .app-tabs__content')
    const className = 'active'

    $title.on('click', function() {
      if(!($(this).hasClass(className))) {
        $title.removeClass(className)
        $(this).addClass(className)
        const index = $(this).attr('data-index')

				$content.fadeOut(300)
				setTimeout(()=>{
					$content.removeClass(className)
				}, 300)  
				$(this).parent().next().find(`[data-index=${index}]`).fadeIn(300)  
				setTimeout(()=>{
					$(this).parent().next().find(`[data-index=${index}]`).addClass(className)
				}, 300)             
      }
    })
  }
  
  function pageFaq() {
    const fTabsLink = $('.f-tabs__link');
    const fTabsTabMain = $('.f-tabs__tab_main');
    const fTabsNavLink = $('.f-tabs__nav_link');
    const fTabsAcordion = $('.f-tabs__acordion');
    const fTabsHeading = $('.f-tabs__heading');

    if ( fTabsLink.length ) {
      fTabsLink.click(function(e) {
        e.preventDefault();
        
        fTabsLink.removeClass('active');
        $(this).addClass('active');

        fTabsNavLink.removeClass('active');
        fTabsNavLink.eq(0).addClass('active');

        fTabsTabMain.removeClass('active');
        fTabsTabMain.eq($(this).data('tabMainLink')).addClass('active');

        fTabsHeading.removeClass('active'); 

        fTabsAcordion.each(function(element){
          if ($(this).data('tabBox') === 'tab1' ) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        })
      })
    }

    if ( fTabsNavLink.length ) {
      fTabsNavLink.click(function(e) {
        e.preventDefault();

        fTabsNavLink.removeClass('active');
        $(this).addClass('active');

        let activeTab = $(this).data('tab');
        fTabsAcordion.each(function(element){
          if ($(this).data('tabBox') === activeTab ) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        })

      })
    }
    if ( fTabsHeading.length ) {
      fTabsHeading.click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
      })
    }
  }

  function anchorScroll() {
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();
  
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 70
      }, 500);
  	});
  }

	function locationPopupInit() {
		const $popup = $('.location-popup');

		window.location.hash == '#redr' && sessionStorage.setItem('redirect', true);

		!sessionStorage.getItem('redirect') && !sessionStorage.getItem('open-popup') && setTimeout(function() {
			$popup.addClass('active')
			sessionStorage.setItem('open-popup', true)
		}, 5000);

		$(document).on('click', '.location-switcher', () => $popup.addClass('active'));

		$(document).on('click', '.location-popup__close, .location-popup__overlay', () =>	$popup.removeClass('active'));

		$(document).on('click', '.location-popup__button', (e) => {
			e.preventDefault();

			let location = $('.location-popup__select').val();
			let url = $(`.location-switcher[data-location="${location}"]`).data('url');

			if (!window.location.origin.includes(url)) {
				sessionStorage.removeItem('redirect');
				sessionStorage.removeItem('open-popup');
				window.location.href = url + window.location.pathname +'/#redr';
			}
		})
	}

	const coolingMenuItems = document.querySelectorAll('.coming-soon-dis')
	if(coolingMenuItems) {
		coolingMenuItems.forEach(el => {
				el.style.cursor = "not-allowed"
				el.style.pointerEvents = "none"
				el.addEventListener('click', (e)=>{
					e.preventDefault
				})
		});		
	}


  announcement();
  mobileMenu();
	locationPopupInit();
  lazy();
  sliders();
  homeAnimation();
  instFunctions();
  header();
  productLanding();
  homeApps();
  productLanding();

  specification();
  variants();
  kitMedia();
  kitPopup();
  pageHeader();
  appTabs();
	collectionsTabs();

  pageFaq();
  anchorScroll();

  AOS.init();
})
 